import React ,{useState}from 'react'
import { Link } from 'react-router-dom'
import { useDisclosure, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react'
import { useFlutterwave } from 'react-flutterwave';
import * as ROUTES from '../../../utils/constants/routes'
import {paymentConfig} from '../../../utils/constants/payments/flutterwaveConfig'

export default function About() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    var _paymentConfig = paymentConfig;
    const handleFlutterPayment = useFlutterwave(_paymentConfig);
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [amount, setAmount] = useState(0)
    return (
        <section className="about-area">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-6 p-0">
                    <div className="about-image about-img-two ptb-100">
                        <img src="./assets/img/about/about-image.jpg" alt="About US"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="about-item about-item-two ptb-100">
                        <span>
                            <i className="flaticon-care-about-plants"></i>
                            About us
                        </span>
                        <h3>An international independent Charity organization</h3>
                        <p className="main-color">
                            Your support will help us to make life better living for poor vulnerable children
                            
                        </p>
                        <p>
                        Child hope international children ministries is a non-profit charity organization formed in 2009 in Uganda which focuses on children who are orphans, have single parents, are homeless, sexually abused, malnourished, living in abject poverty as they experience all the side effects of war and HIV/AIDS. 
                                    <br/>We take on the responsibility to educate, counsel, give medical support, feed children daily, provide clothing for some and hopefully in the future provide shelter where necessary. We also use this opportunity to teach them good moral values based on the word of God. 
                                    Every outreach to the communities we reach is done in a loving and caring environment that promotes hopefulness. 
                                    <br/>Please join our efforts to create real change and manifest our vision into reality.
                            </p>
                        <div className="about-btn">
                            <a  href="#" className="default-btn" onClick={onOpen}  >
                                Donate now
                            </a>
                            <Link  to= {ROUTES.ABOUT}className="optional-btn" href="#">
                                More about us
                                <i className="flaticon-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
                <ModalContent>
                    <form className="donate-form">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" name="name" className="form-control" placeholder="Your Full Name " onChange={e => setName(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <div className="select-box">
                                        <select className="form-control">
                                            <option value="5">Your Country</option>
                                            <option value="1">China</option>
                                            <option value="2">United Kingdom</option>
                                            <option value="0">Germany</option>
                                            <option value="3">France</option>
                                            <option value="4">Japan</option>

                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-group">
                                    <div className="form-group">
                                        <input type="text" name="email" className="form-control" placeholder="Your email" onChange={e => setEmail(e.target.value)} />
                                    </div>
                                    <div className="select-box">
                                        <select className="form-control" onChange={e => setAmount(e.target.value)}>
                                            <option value="400">$400</option>
                                            <option value="500">$500</option>
                                            <option value="600">$600</option>
                                            <option value="50">$50</option>
                                            <option value="1000">$1000</option>
                                            <option value="100">$100</option>
                                        </select>
                                        <span className="usd">$ USD</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="donate-form-btn">
                                    <a  href="#" className="default-btn" onClick={
                                        () => {
                                            _paymentConfig.amount = amount;
                                            _paymentConfig.customer.email = email;
                                            _paymentConfig.customer.name = name;
                                            handleFlutterPayment({
                                                callback: (response) => {
                                                    console.log(response);
                                                },
                                                onClose: () => {

                                                },
                                            });
                                        }
                                    }>
                                        Donate Your Money
                                        <span></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </form>

                </ModalContent>

            </Modal>
          
    </section>
    )
}
